export const getShowSeasonByShowId = () =>
  fetch(
    `${process.env.REACT_APP_API_URL}/ShowSeasonCs?filter[where]` +
      `[showRExternalIdC]=${
        process.env.REACT_APP_SHOW_ID
      }&filter[order]=createdDate DESC&filter[limit]=1`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  ).then(response => response.json());

export const getShowSeasonByShowIdAndActivelyCasting = () =>
  fetch(
    `${process.env.REACT_APP_API_URL}/ShowSeasonCs?filter[where][and]` +
    `[0][showRExternalIdC]=${
      process.env.REACT_APP_SHOW_ID
      }&filter[where][and][1][activelyCastingC]=true`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  ).then(response => response.json());

export const submitApplicants = applicants =>
  fetch(`${process.env.REACT_APP_API_URL}/SalesForces`, {
    method: 'POST',
    body: JSON.stringify(applicants),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.json());



// WEBPACK FOOTER //
// ./src/api/showSeasonAPI.js